"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DOCUMENTS = void 0;
const client_1 = require("@apollo/client");
const __queries__1 = require("../../../DocumentUploads/__queries__");
exports.GET_DOCUMENTS = (0, client_1.gql) `
  query getDocumentsForProperty($propertyId: ID!, $isGuest: Boolean!) {
    property(propertyId: $propertyId) {
      id
      documentUploads(filterHidden: false, filterProcessing: false) {
        ...DocumentUploadDataFragment

        elevationCertificate {
          id
        }

        certificateUpload {
          id
          status
        }
      }
    }
  }

  ${__queries__1.DOCUMENT_UPLOAD_DATA_FRAGMENT}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RG9jdW1lbnRzRm9yUHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0FkZHJlc3NQYW5lbC9Eb2N1bWVudFVwbG9hZHMvX19xdWVyaWVzX18vZ2V0RG9jdW1lbnRzRm9yUHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQXFDO0FBQ3JDLHFFQUFxRjtBQUV4RSxRQUFBLGFBQWEsR0FBRyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQW1CNUIsMENBQTZCO0NBQ2hDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBncWwgfSBmcm9tIFwiQGFwb2xsby9jbGllbnRcIjtcbmltcG9ydCB7IERPQ1VNRU5UX1VQTE9BRF9EQVRBX0ZSQUdNRU5UIH0gZnJvbSBcIi4uLy4uLy4uL0RvY3VtZW50VXBsb2Fkcy9fX3F1ZXJpZXNfX1wiO1xuXG5leHBvcnQgY29uc3QgR0VUX0RPQ1VNRU5UUyA9IGdxbGBcbiAgcXVlcnkgZ2V0RG9jdW1lbnRzRm9yUHJvcGVydHkoJHByb3BlcnR5SWQ6IElEISwgJGlzR3Vlc3Q6IEJvb2xlYW4hKSB7XG4gICAgcHJvcGVydHkocHJvcGVydHlJZDogJHByb3BlcnR5SWQpIHtcbiAgICAgIGlkXG4gICAgICBkb2N1bWVudFVwbG9hZHMoZmlsdGVySGlkZGVuOiBmYWxzZSwgZmlsdGVyUHJvY2Vzc2luZzogZmFsc2UpIHtcbiAgICAgICAgLi4uRG9jdW1lbnRVcGxvYWREYXRhRnJhZ21lbnRcblxuICAgICAgICBlbGV2YXRpb25DZXJ0aWZpY2F0ZSB7XG4gICAgICAgICAgaWRcbiAgICAgICAgfVxuXG4gICAgICAgIGNlcnRpZmljYXRlVXBsb2FkIHtcbiAgICAgICAgICBpZFxuICAgICAgICAgIHN0YXR1c1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgJHtET0NVTUVOVF9VUExPQURfREFUQV9GUkFHTUVOVH1cbmA7XG4iXX0=